module.exports = __webpack_public_path__ + "static/media/bridge3.adf5a203.jpg";